import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Container, Label, Input } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import axios from "axios";
import { API_BASE_URL } from "../../constants"; 

const Office = () => {
    const [breadcrumbItems] = useState([
        { title: "School", link: "#" },
        { title: "Office details", link: "#" },
    ]);
    const [officeDetails, setOfficeDetails] = useState(null); 
    const [loading, setLoading] = useState(true);

    // Fetch office details from API
    useEffect(() => {
        axios.post(`${API_BASE_URL}/admin/office`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token") 
            }
        })
            .then(response => {
                setOfficeDetails(response.data.data.office); 
                setLoading(false); 
            })
            .catch(error => {
                console.error("There was an error fetching the office details:", error);
                setLoading(false); 
            });
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Forms Elements" breadcrumbItems={breadcrumbItems} />

                    <Row>
                        <Col lg={4}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">Office name</h4>
                                    <p className="card-title-desc">Office address</p>
                                    <div>
                                        {/* Display office name and address */}
                                        {loading ? (
                                            <p>Loading...</p>
                                        ) : officeDetails ? (
                                            <>
                                                <p>{officeDetails.name}</p> 
                                                <p>{officeDetails.address}</p>
                                            </>
                                        ) : (
                                            <p>Error loading office details</p>
                                        )}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={8}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">Office details</h4>
                                    <p className="card-title-desc">Update details</p>

                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : officeDetails ? (
                                        <>
                                            <Row className="mb-3">
                                                <Label htmlFor="office-name" className="col-md-2 col-form-label">Name</Label>
                                                <Col md={10}>
                                                    <Input
                                                        type="text"
                                                        defaultValue={officeDetails.name}
                                                        id="office-name"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label htmlFor="office-address" className="col-md-2 col-form-label">Address</Label>
                                                <Col md={10}>
                                                    <Input
                                                        type="text"
                                                        defaultValue={officeDetails.address}
                                                        id="office-address"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label htmlFor="office-email" className="col-md-2 col-form-label">Email</Label>
                                                <Col md={10}>
                                                    <Input
                                                        type="email"
                                                        defaultValue={officeDetails.email1}
                                                        id="office-email"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label htmlFor="office-phone" className="col-md-2 col-form-label">Phone</Label>
                                                <Col md={10}>
                                                    <Input
                                                        type="text"
                                                        defaultValue={officeDetails.phone1}
                                                        id="office-phone"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label htmlFor="office-website" className="col-md-2 col-form-label">Website</Label>
                                                <Col md={10}>
                                                    <Input
                                                        type="text"
                                                        defaultValue={officeDetails.website}
                                                        id="office-website"
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                    ) : (
                                        <p>Error loading office details</p>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Office;
